import { render, staticRenderFns } from "./indicators-timeline.vue?vue&type=template&id=68245ac3&scoped=true&"
import script from "./indicators-timeline.vue?vue&type=script&lang=js&"
export * from "./indicators-timeline.vue?vue&type=script&lang=js&"
import style0 from "./indicators-timeline.vue?vue&type=style&index=0&id=68245ac3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68245ac3",
  null
  
)

/* custom blocks */
import block0 from "./indicators-timeline.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports